/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCollection = {
  init: function($section) {

    window.PXUTheme.jsCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

    if (!isIE11) {
      window.Shopify.loadFeatures([
        { name: 'shopify-xr', version: '1.0' },
        { name: 'model-viewer-ui', version: '1.0' }
      ]);
    }

    if (this.enable_sorting == true) {
      $('#sort-by').val($('#sort-by').data('default-sort'));
    }

    if (this.enable_filter == true || this.enable_sorting == true) {
      $('#tag_filter, #sort-by').on('change', function() {
        window.PXUTheme.jsCollection.filterURL();
      });
    }

    if ($('[data-option-filter]').length) {
      $('[data-tag-filter-checkbox]:checked').each(function(){
        window.PXUTheme.jsCollection.multiTagFilter.showSelectedFilter($(this));
      });
    }

    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      window.PXUTheme.breadcrumbs.init(this.number_of_pages);
    }

    $('body').on('click', '[data-option-filter]', function(e) {
      e.preventDefault();
      $(this).find('input').prop('checked', true);
      window.PXUTheme.jsCollection.multiTagFilter.init($(this));
      window.PXUTheme.scrollToTop($('.collection__content'));
    });

    $('body').on('click', '[data-clear-filter]', function () {
      const $el = $(this).siblings('[data-option-filter]');
      const $productTagFilter = $('#tag_filter');

      $productTagFilter.find('option:eq(0)').prop('selected', true);
      window.PXUTheme.jsCollection.multiTagFilter.clearSelectedFilter($el);
      window.PXUTheme.scrollToTop($('.collection__content'));
    });
  },

  filterURL: function() {

    var selectedOptions = [],
        query = '',
        currentTags = '';

    var path = window.location.pathname.replace(/\?.*$/, '');

    if (path.slice(-1) !== '/') {
      path += '/';
    }

    if ($('#sort-by').length){
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length){
      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
        var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag !== 'all' && $.inArray(urlTag, selectedOptions) === -1) {
          selectedOptions.unshift(urlTag);
        }
      }
    }

    $('[data-option-filter] input:checked').each(function () {
      selectedOptions.push($(this).val());
    });

    selectedOptions = $.makeArray(selectedOptions);

    $.each(selectedOptions, function(i, value){
      currentTags += (i !== selectedOptions.length - 1) ? value + '+' : value;
    });

    window.PXUTheme.queryParameters.sort_by = query;
    query = '?' + $.param(window.PXUTheme.queryParameters);

    this.processUrl(path, currentTags, query);
  },

  processUrl: function (path, tags, query) {
    query = query.replace(/\page=(\w+)&/, '');
    var urlString = path + tags + query;
    this.updateView(urlString);
  },

  updateView: function(filterURL) {
    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function() {
        $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
        $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
      },
      error: function() {
        location.replace(location.protocol + '//' + location.host + filterURL);
      },
      dataType: "html"
    }).then(function(data){

      const $breadcrumbContainer = $('.breadcrumb__container');
      const $collectionMatrix = $('.collection-matrix');
      const $collectionMain = $('[data-collection-main]');

      const filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
      $breadcrumbContainer.html(filteredBreadcrumb);

      $collectionMatrix.removeClass('fadeIn animated loading-in-progress');

      const filteredData = $(data).find('.collection-matrix__wrapper');
      const filteredPageLinks = $(data).find('.container--pagination');
      const noProducts = $(data).find('.container--no-products-in-collection');

      $collectionMain.empty();

      if (filteredData.length) {
        $collectionMain.append(filteredData);
      } else {
        $collectionMain.append(noProducts);
      }

      $collectionMain.append(filteredPageLinks);

      window.history.pushState("", "", filterURL);

      if ($('[data-custom-pagination]').length) {
        window.PXUTheme.infiniteScroll.init();
      }
    });
  },

  multiTagFilter: {
    init: function ($el) {
      this.showSelectedFilter($el);
      window.PXUTheme.jsCollection.filterURL();

      var urlIndex = window.PXUTheme.routes.root_url.length > 1 ? 3 : 2;

      if ($.url(urlIndex) === 'types' || $.url(urlIndex) === 'vendors') {
        $('.block__tag-filter').remove();
      }
    },

    showSelectedFilter: function ($el) {
      const $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.addClass('is-active');
      $filterItem.siblings(':not(.is-active)').addClass('is-hidden');
      $filterItem.find('[data-clear-filter]').removeClass('is-hidden');

      if ($sidebarToggleBlock.length) {
        let $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');
        window.PXUTheme.jsSidebar.openSidebarBlock($toggleBtn);
      }
    },

    clearSelectedFilter: function ($el) {
      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.removeClass('is-active')
        .find('input').prop("checked", false);

      $filterItem.siblings().removeClass('is-hidden');
      $filterItem.find('[data-clear-filter]').addClass('is-hidden');

      window.PXUTheme.jsCollection.filterURL();
    }
  },

  unload: function() {
    $('#tag_filter, #sort-by').off();
    $('[data-option-filter]').off();
    $('[data-reset-filters]').off();
    $('[data-clear-filter]').off();
    window.PXUTheme.breadcrumbs.unload();
  }
}

/******/ })();
